var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-with-icon"},[_c('div',{staticClass:"alert-icon"},[_vm._t("icon",[_c('i',{staticClass:"icon-warning"})])],2),_c('div',{staticClass:"alert-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }